var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.47966C14.0019 9.07305 13.7818 9.64529 13.3838 10.082C12.9859 10.5187 12.4393 10.7876 11.8533 10.8351C10.6944 10.9215 9.08444 11 7 11C4.91556 11 3.30556 10.9215 2.14668 10.8351C1.56074 10.7876 1.01415 10.5187 0.61616 10.082C0.218175 9.64529 -0.0018718 9.07305 1.19959e-05 8.47966V2.51249C-0.0018718 1.9191 0.218175 1.34686 0.61616 0.910163C1.01415 0.473467 1.56074 0.204499 2.14668 0.157031C3.30556 0.0785152 4.91556 0 7 0C9.08444 0 10.6944 0.0785154 11.8533 0.164882C12.4379 0.212245 12.9834 0.480102 13.3812 0.915131C13.779 1.35016 13.9999 1.92046 14 2.51249V8.47966ZM5.44445 3.14061V7.85153L9.33333 5.49607L5.44445 3.14061Z",
    fill: "#23F6CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.8a3a81adc6ef73e3d936b2c2564fe85c.svg";
export { ForwardRef as ReactComponent };